import { z } from "zod";
import { paginatedResponse } from "../utils";

const DraftSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    nr: z.string(),
    description: z.string(),
    language: z.string(),
    file_name: z.string(),
    created: z.string(),
    subject: z.string().nullable().optional(),
    body: z.string().nullable().optional(),
    active: z.boolean(),
    draft_notification: z.string().nullable().optional(),
    draft_notification_id: z.string().nullable().optional(),
});

const getDraftsResponseSchema = paginatedResponse(DraftSchema);

const generateMailResponseSchema = z.object({
    subject: z.string(),
    body: z.string(),
});

const generateOfferPdfRequestSchema = z.object({
    offer_id: z.string().uuid(),
    document_ids: z.array(z.string().uuid()).optional().nullable()
});

const generateAgreementPdfRequestSchema = z.object({
    agreement_id: z.string().uuid(),
});

const updateOfferDraftRequestSchema = z.object({
    nr: z.string(),
    name: z.string(),
    description: z.string(),
    language: z.string(),
    active: z.boolean(),
});

const createDocxDraftResponseSchema = z.object({
    nr: z.string(),
    name: z.string(),
    description: z.string(),
    language: z.string(),
});

const createDocxDraftRequestSchema = z.object({
    nr: z.string(),
    name: z.string(),
    description: z.string(),
    language: z.string(),
    content: z.instanceof(File),
    active: z.boolean(),
    is_offer: z.boolean(),
    is_agreement: z.boolean(),
});

const createEmailDraftRequestSchema = z.object({
    nr: z.string(),
    name: z.string(),
    description: z.string(),
    subject: z.string(),
    body: z.string(),
    language: z.string(),
    active: z.boolean(),
    draft_notification: z.string().optional().nullable()
});

const updateEmailDraftRequestSchema = z.object({
    nr: z.string(),
    name: z.string(),
    description: z.string(),
    subject: z.string(),
    body: z.string(),
    language: z.string(),
    active: z.boolean(),
});

const emailDraftResponseSchema = z.object({
    nr: z.string(),
    name: z.string(),
    description: z.string(),
    language: z.string(),
});

export const draftApiSchema = {
    draft: DraftSchema,
    draftUpdateResponse: updateOfferDraftRequestSchema,
    getDraftsResponse: getDraftsResponseSchema,
    generateMailResponse: generateMailResponseSchema,
    generateOfferPdfRequest: generateOfferPdfRequestSchema,
    generateAgreementPdfRequest: generateAgreementPdfRequestSchema,
    updateOfferDraftRequest: updateOfferDraftRequestSchema,
    createDocxDraftRequest: createDocxDraftRequestSchema,
    createDocxDraftResponse: createDocxDraftResponseSchema,
    createEmailDraftRequest: createEmailDraftRequestSchema,
    updateEmailDraftRequest: updateEmailDraftRequestSchema,
    emailDraftResponse: emailDraftResponseSchema,
};
